import { Categories } from '@/enums/category'

export const getInsuranceCategoryNameKey = (categoryId: string) => {
  return Categories[categoryId as keyof typeof Categories]
    ? `categories.${Categories[categoryId as keyof typeof Categories].key}.name`
    : 'common.insurance'
}
